export const AlertTypes = {
  NewOpp: "New Opportunity For Service Providers.",
  ClosingDateOppSS: "Closing Date Opportunity For Service Seekers.",
  ClosingDateOppSP: "Closing Date Opportunity For Service Providers.",
  AdminDispatch: "Admin Dispatch",
};
